// ABOUTME: Hook that returns conditional terminology based on family timezone
// ABOUTME: Returns "ohana" for Hawaii (Pacific/Honolulu), "family" for all others

import { useMemo } from 'react';
import { useTimezone } from '../contexts/TimezoneContext';

export interface FamilyTerminology {
  term: string;
  Term: string;
  terms: string;
  Terms: string;
  termPossessive: string;
  TermPossessive: string;
  basePath: string;
}

export const useFamilyTerminology = (): FamilyTerminology => {
  const { familyTimezone } = useTimezone();

  return useMemo(() => {
    const isHawaii = familyTimezone === 'Pacific/Honolulu';
    const baseTerm = isHawaii ? 'ohana' : 'family';
    const capitalizedTerm = baseTerm.charAt(0).toUpperCase() + baseTerm.slice(1);

    return {
      term: baseTerm,
      Term: capitalizedTerm,
      terms: isHawaii ? 'ohanas' : 'families',
      Terms: isHawaii ? 'Ohanas' : 'Families',
      termPossessive: `${baseTerm}'s`,
      TermPossessive: `${capitalizedTerm}'s`,
      basePath: isHawaii ? '/ohana' : '/family',
    };
  }, [familyTimezone]);
};
